/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable radix */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  Search, Filter, Download, ReportMoney, ClockHour4, CircleX, AlertCircle,
} from 'tabler-icons-react';
import {
  TextInput, Tooltip, useMantineColorScheme, Progress,
} from '@mantine/core';
import { Card, ConfigProvider } from 'antd';
import { assetPrefix, displayDateV2, renderNumber } from '../../../utilities/general';
import CustomSelect from '../../Listing/companyData/Select';
import styles from './PositionsTabV2.module.css';
import CircleCheck from '../../../components/CommonFunction/CircleCheck';
import CircleXIcon from '../../../components/CommonFunction/CircleXIcon';

export default function OrdersTabV2(props) {
  const [searchValue, setSearchValue] = useState('');
  const { colorScheme } = useMantineColorScheme();

  const [selectOptions, setSelectOptions] = useState('all');

  const orderTypeClasses = {
    'Limit Buy': 'border border-[#BEDBFF] text-[#0861C7] bg-[#EFF6FF]',
    'Limit Sell': 'border border-[#E9D4FF] text-[#9810FA] bg-[#FAF5FF]',
    'Market Sell': 'border border-[#FFC9C9] text-[#E7000B] bg-[#FEF2F2]',
    'Market Buy': 'border border-[#A4F4CF] text-[#009966] bg-[#ECFDF5]',
    'Stop Loss': 'border border-[#FFD6A7] text-[#F54900] bg-[#FFF7ED]',
  };

  const orderStatusClasses = {
    Pending: {
      icon: <ClockHour4 size={16} color="#F0B100" />,
      classes: 'border border-[#FFF085] text-[#D08700] bg-[#FEFCE8]',
    },
    Filled: {
      icon: <CircleCheck height={16} width={16} stroke="#00BC7D" />,
      classes: 'border border-[#A4F4CF] text-[#009966] bg-[#ECFDF5]',
    },
    Cancelled: {
      // icon: <CircleX size={16} color="#FB2C36" />,
      icon: <CircleXIcon />,
      classes: 'border border-[#FFC9C9] text-[#E7000B] bg-[#FEF2F2]',
    },
    'Partially Filled': {
      icon: <AlertCircle size={16} color="#2B7FFF" />,
      classes: 'border border-[#BEDBFF] text-[#0861C7] bg-[#EFF6FF]',
    },
  };

  const data = [
    { value: 'all', label: 'All Orders' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Filled', label: 'Filled' },
    { value: 'Cancelled', label: 'Cancelled' },
    { value: 'Buy Orders', label: 'Buy Orders' },
    { value: 'Sell Orders', label: 'Sell Orders' },
  ];

  const orderData = [
    {
      marketPair: 'BTC/USDT',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png', // Bitcoin
      tradingProductType: 'Bitcoin',
      unitPrice: 43250.5,
      quantity: 0.25,
      totalPrice: 10812.63,
      totalPriceUsd: 10812,
      type: 'Limit Buy',
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Binance',
      status: 'Pending',
    },
    {
      marketPair: 'ETH/USDT',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png', // Ethereum
      tradingProductType: 'Ethereum',
      unitPrice: 2456.78,
      quantity: 5.0,
      totalPrice: 12283.9,
      totalPriceUsd: 12283,
      type: 'Market Sell',
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Coinbase',
      status: 'Filled',
    },
    {
      marketPair: 'SOL/USDT',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png', // Solana
      tradingProductType: 'Solana',
      unitPrice: 98.65,
      quantity: 50,
      totalPrice: 4932.5,
      totalPriceUsd: 12283,
      type: 'Stop Loss',
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Kraken',
      status: 'Pending',
    },
    {
      marketPair: 'ADA/USDT',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2010.png', // Cardano
      tradingProductType: 'Cardano',
      unitPrice: 0.45,
      quantity: 10000,
      totalPrice: 4500,
      totalPriceUsd: 12283,
      type: 'Limit Sell',
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Binance',
      status: 'Cancelled',
    },
    {
      marketPair: 'DOT/USDT',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6636.png', // Polkadot
      tradingProductType: 'Polkadot',
      unitPrice: 6.78,
      quantity: 150,
      totalPrice: 1017,
      totalPriceUsd: 12283,
      type: 'Limit Buy',
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Kraken',
      status: 'Filled',
    },
    {
      marketPair: 'MATIC/USDT',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3890.png', // Polygon
      tradingProductType: 'Polygon',
      unitPrice: 0.89,
      quantity: 2000,
      totalPrice: 1780,
      totalPriceUsd: 12283,
      type: 'Market Buy',
      timeStamp: '2024-01-15 14:32:21',
      platform: 'Coinbase',
      status: 'Partially Filled',
    },
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            bodyPadding: 16,
            borderRadiusLG: 14,
          },
        },
      }}
    >
      <div>
        <div className="flex flex-col gap-6 mx-auto">
          <div className="flex flex-col gap-1">
            <h1 className="text-2xl font-bold text-[#101828] dark:text-white">Orders</h1>
            <p className="text-base font-normal text-[#4A5565] dark:text-[#898989]">Monitor and manage your trading orders</p>
          </div>
          <div className="grid grid-cols-4 gap-4">
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Total Orders</div>
              <div className="text-2xl font-bold text-[#101828] dark:text-[#BEB9B9]">
                6
              </div>
            </Card>
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Pending</div>
              <div className="text-2xl font-bold text-[#D08700]">
                2
              </div>
            </Card>
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Filled</div>
              <div className="text-2xl font-bold text-[#009966]">
                2
              </div>
            </Card>
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Cancelled</div>
              <div className="text-2xl font-bold text-[#FB2C36]">
                1
              </div>
            </Card>
          </div>
          <div className="flex flex-col items-start gap-[46px] rounded-[14px] bg-white dark:bg-[#26282C] p-6 shadow-md flex-shrink-0 self-stretch">
            <div className="w-full flex justify-between items-center">
              <div className="h-9 flex justify-center items-start gap-4">
                <TextInput
                  classNames={{
                    input: 'bg-[#FAFAFA] dark:bg-[#1a1b1e] dark:border-neutral-600 border-[#E5E7EB]',
                  }}
                  className="w-80"
                  placeholder="Search orders..."
                  radius="md"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.currentTarget.value)}
                  icon={<Search size={16} color="#99A1AF" />}
                />
                <CustomSelect
                  options={data}
                  value={selectOptions}
                  onChange={setSelectOptions}
                  icon={<Filter size={16} color="#717182" />}
                />
              </div>
              <div className={`${styles.padding} border border-[#0000001A] dark:border-neutral-600 dark:bg-[#1a1b1e] rounded-lg`}>
                <Download size={16} color={colorScheme === 'dark' ? '#898989' : '#0A0A0A'} />
                <span className="text-sm font-medium text-[#0A0A0A] dark:text-[#898989]">Export</span>
              </div>
            </div>
            <div className={`${styles.grid} w-full h-full flex flex-col items-start border border-[#F3F4F6] dark:border-neutral-600 dark:bg-[#1a1b1e] rounded-[10px]`}>
              <div className={`w-full h-10 grid items-center p-2 rounded-t-lg border-b border-[#0000001A] bg-[#F9FAFB80] dark:border-neutral-600 dark:bg-[#1a1b1e] ${styles.OrdersTabHeadingGrid}`}>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Market Pair
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Unit Price
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Quantity
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Total Price
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Type
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Timestamp
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Platform
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Status
                </div>
              </div>
              {orderData.map((items) => {
                const { icon, classes } = orderStatusClasses[items.status];
                return (
                  <div className={`w-full h-[73px] grid items-center p-2 rounded-t-lg border-b border-[#0000001A] dark:border-neutral-600 last:border-none ${styles.OrdersTabRowGrid}`}>
                    <div className="flex items-center gap-3 text-base font-normal">
                      {items?.icon
                        ? (
                          <img
                            className="w-8 h-8 rounded-full"
                            src={items?.icon || `${assetPrefix}/images/CrptoIcon.svg`}
                            alt="Crypto"
                          />
                        )
                        : <ReportMoney className="w-11 h-11" />}

                      <div className="flex items-center">
                        <span
                          className={`${styles.title} font-semibold text-[#101828] dark:text-[#898989]`}
                        >
                          {items?.marketPair?.length > 10 ? `${items?.marketPair?.slice(0, 8)}...` : items?.marketPair.toUpperCase() || '-'}
                        </span>
                      </div>
                    </div>
                    <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                      {renderNumber(items?.unitPrice, true)}
                    </div>
                    <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                      {renderNumber(items?.quantity)}
                    </div>
                    <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                      {`${renderNumber(items?.totalPrice, true)} (~${renderNumber(items?.totalPriceUsd, true)})`}
                    </div>
                    <div className={`${orderTypeClasses[items?.type]} w-fit text-xs rounded-lg px-2 py-1 font-medium`}>
                      {items?.type}
                    </div>
                    <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                      {displayDateV2(items.timeStamp)}
                    </div>
                    <div className="text-xs w-fit font-medium rounded-lg py-1 px-2 border bg-[#F9FAFB] text-[#0A0A0A] border-[#0000001A]">
                      {items?.platform}
                    </div>
                    <div className="w-fit flex items-center text-xs gap-2 font-medium">
                      {icon && icon}
                      <span className={`py-0.5 px-2 rounded-lg ${classes}`}>{items.status}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
}
